import React, { lazy, Suspense } from "react";
import DialogHeader from "./footer/DialogHeader";
import DialogFooter from "./footer/DialogFooter";

interface DialogsmallProps {
  isOpen: boolean;
  handleClose: () => void;
  handleFooterSubmit?: () => void;
  handleDeleteSubmit?: () => void;
  children: React.ReactNode;
  title: string;
  subtitle: string;
  cancel: string;
  submit: string;
  delete?: string;
  type?: "button" | "submit";
  buttonloading?: boolean;
  submitDisabled?: boolean;
  requiredMessage?: string;
  HorizontalLine?: boolean;
}

// Lazy-load wrapper for Vite/CRA
const DialogOnlyWrapper = lazy(() => import("./DialogOnlyWrapper"));

const Dialogsmall: React.FC<DialogsmallProps> = ({
  isOpen,
  handleClose,
  handleFooterSubmit,
  handleDeleteSubmit,
  children,
  title,
  subtitle,
  cancel,
  submit,
  type,
  delete: deleteLabel,
  buttonloading,
  submitDisabled,
  requiredMessage,
  HorizontalLine,
}) => {
  if (!isOpen) return null;

  const isSuccessScreen =
    React.isValidElement(children) &&
    children.type &&
    (children.type as any).name === "RequestToPaySuccess";

  return (
    <Suspense fallback={<div />}>
      <DialogOnlyWrapper>
        <div className="gx-dialog-box">
          <DialogHeader
            handleClose={handleClose}
            title={title}
            subtitle={subtitle}
          />
          <div className="gx-dialog-main">{children}</div>

          {!isSuccessScreen && (
            // <DialogFooter
            //   handleClose={handleClose}
            //   handleFooterSubmit={handleFooterSubmit}
            //   cancel={cancel}
            //   submit={submit}
            //   type={type}
            //   buttonloading={buttonloading}
            //   submitDisabled={submitDisabled}
            //   requiredMessage={requiredMessage}
            // />
            <DialogFooter
              handleClose={handleClose}
              handleFooterSubmit={handleFooterSubmit}
              handleDeleteSubmit={handleDeleteSubmit}
              cancel={cancel}
              submit={submit}
              delete={deleteLabel}
              type={type}
              buttonloading={buttonloading}
              submitDisabled={submitDisabled}
              requiredMessage={requiredMessage}
              HorizontalLine={HorizontalLine}
            />
          )}
        </div>
      </DialogOnlyWrapper>
    </Suspense>
  );
};

export default Dialogsmall;
